var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"usage-terms"},[_c('usage-terms-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }